
export const FooterConfig = {
  /**
   * 小程序二维码图片
   */
  weChatAppletImg: require('@/assets/images/weChatApplet.png'),
  /**
   * 公众号二维码图片
   */
  weChatOfficialAccountImg: require('@/assets/images/weChatOfficialAccount.png'),
    /**
     * 数字备案
     */
    digital: '0755-86185583',
    /**
     * 作品登记
     */
    registration: '86660433 / 86185560',
    /**
     * 会员部电话
     */
    membership: '0755-86716210',
    /**
     * 地址
     */
    address: '深圳市南山区沙河西路深圳湾科技生态园6栋6楼',
    /**
     * 软件登记
     */
    softwareRegistration: '86185515',
    /**
    * 证据固化
    */
    evidenceSolidification: '86185516 / 86185515',
    /**
     * 邮箱
     */
    email: 'szcopyright@163.com',
}

